import { Button, Select } from '@tunasong/ui-lib'
import { useEditorClass } from '@tunasong/editor'
import { graphHooks } from '@tunasong/graph-lib/react'
import { useIsLocalHost } from '@tunasong/redux'
import { Dialog } from '@tunasong/ui-lib'
import type { ChangeEvent, FC } from 'react'
import { useState } from 'react'
import { useReleaseNotes } from './release-notes.hook.js'
import styles from './release-notes-dialog.module.css'

export interface ReleaseNotesDialogProps {}

export const ReleaseNotesDialog: FC<ReleaseNotesDialogProps> = props => {
  const {} = props
  const { releaseNotes, latestUnread, setReadVersion, isReady } = useReleaseNotes()
  const PageEditor = useEditorClass('PageEditor')

  const [selectedVersion, setSelectedVersion] = useState<string>()

  const handleClose = () => {
    if (latestUnread?.version) {
      setReadVersion(latestUnread?.version)
    }
    setSelectedVersion(undefined)
  }

  const version = selectedVersion || latestUnread?.version
  const handleVersion = (e: ChangeEvent<HTMLSelectElement>) => setSelectedVersion(e.target.value)

  /** Release notes are cloud pages; a local kernel has none, so it neither asks nor shows the dialog */
  const isLocalHost = useIsLocalHost()
  const currentReleaseNote = isLocalHost ? undefined : releaseNotes.find(r => r.version === version)

  const { entity } = graphHooks.useEntity(currentReleaseNote?.entityId)

  // We need to set the meta tag to ready when the release notes have loaded
  // This is when isReady is set, and either currentReleaseNote is not set or entity is set
  const metaLoaded = Boolean(isReady && (!currentReleaseNote || entity))

  // Helper for the tests, we want to know if the release notes are loaded
  const metaTag = <meta name="release-notes-loaded" content={metaLoaded.toString()} />

  if (!entity) {
    return metaTag
  }

  return (
    <>
      {metaTag}
      <Dialog
        fullWidth
        maxWidth="sm"
        title="Release Notes"
        open={true}
        onClose={handleClose}
        controls={
          <Select className={styles.versionSelect} value={version} onChange={handleVersion}>
            {releaseNotes.map(r => (
              <option key={r.version} value={r.version}>
                {r.version}
              </option>
            ))}
          </Select>
        }
      >
        <PageEditor element={entity} readOnly={true} />
        <Button onClick={handleClose}>Close</Button>
      </Dialog>
    </>
  )
}
